import { render, staticRenderFns } from "./new-drip-message-dialog.vue?vue&type=template&id=5dbb2c16&scoped=true&"
import script from "./new-drip-message-dialog.vue?vue&type=script&lang=js&"
export * from "./new-drip-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb2c16",
  null
  
)

export default component.exports